$(function () {
  $('a[href^="#"]').click(function () {
    let speed = 800;
    let headerHeight = 138;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top - headerHeight;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

$(function () {
  $('.burger').on('click', function () {
    $('.sp_nav').toggleClass('active');
    $(this).toggleClass('toggle');
    $('body').toggleClass('noscroll');
  });
});

// $(function () {
//   $('.sp_nav li a').on('click', function () {
//     $('.sp_nav').removeClass('active');
//     $('.burger').removeClass('toggle');
//     $('body').removeClass('noscroll');
//   });
// });

$(function () {
  $('.ac_ttl > a').on('click', function (e) {
    e.preventDefault();
    $(this).next('.sub_menu').slideToggle(200);
    $(this).parent(".ac_ttl").toggleClass('active');
  });
});

// JavaScript Document
$(function () {
  var searchModalMask = $('.search_modal_mask');
  var searchModal = $('.search_modal');
  var searchBox = $('.search_box');
  var searchModalClose = $('.search_modal_close');

  searchBox.on('click', function () {
    searchModalMask.fadeIn();
    searchModal.fadeIn(200);
    $('body').addClass('noscroll');
  });

  searchModalClose.on('click', function () {
    searchModalMask.fadeOut();
    searchModal.fadeOut(200);
    $('body').removeClass('noscroll');
  });
  searchModalMask.on('click', function () {
    searchModal.fadeOut(200);
    $('body').removeClass('noscroll');
    searchModalMask.fadeOut();
  });

  $(".allOn").change(function () { //全選択・全解除をクリックしたとき
    $(this).parents('form').find('.search_modal_category input[type=checkbox]').each(function () {
      if (!$(this).prop('checked')) {
        $(this).parents('label').trigger('click')
      }
    }); return;
  });
  $(".allOff").change(function () { //全選択・全解除をクリックしたとき
    $(this).parents('form').find('.search_modal_category input[type=checkbox]').each(function () {
      if ($(this).prop('checked')) {
        $(this).parents('label').trigger('click')
      }
    }); return;
  });
});


$(function () {

  // ①マウスをボタンに乗せた際のイベントを設定
  $('.open01').hover(function () {

      // ②乗せたボタンに連動したメガメニューをスライドで表示させる
      $(this).find('.megamenu').stop().slideDown();
      $(this).addClass('active');
      // ③マウスをボタンから離した際のイベントを設定
  }, function () {

      // ④マウスを離したらメガメニューをスライドで非表示にする
      $(this).find('.megamenu').stop().slideUp();
      $(this).removeClass('active');

  });

});

$(function () {

  // ①マウスをボタンに乗せた際のイベントを設定
  $('.open02').hover(function () {

      // ②乗せたボタンに連動したメガメニューをスライドで表示させる
      $(this).find('.megamenu').stop().slideDown();
      $(this).addClass('active');
      // ③マウスをボタンから離した際のイベントを設定
  }, function () {

      // ④マウスを離したらメガメニューをスライドで非表示にする
      $(this).find('.megamenu').stop().slideUp();
      $(this).removeClass('active');

  });

});

$(function () {

  // ①マウスをボタンに乗せた際のイベントを設定
  $('.open03').hover(function () {

      // ②乗せたボタンに連動したメガメニューをスライドで表示させる
      $(this).find('.megamenu').stop().slideDown();
      $(this).addClass('active');
      // ③マウスをボタンから離した際のイベントを設定
  }, function () {

      // ④マウスを離したらメガメニューをスライドで非表示にする
      $(this).find('.megamenu').stop().slideUp();
      $(this).removeClass('active');

  });

});

$(function () {

  // ①マウスをボタンに乗せた際のイベントを設定
  $('.open04').hover(function () {

      // ②乗せたボタンに連動したメガメニューをスライドで表示させる
      $(this).find('.megamenu').stop().slideDown();
      $(this).addClass('active');
      // ③マウスをボタンから離した際のイベントを設定
  }, function () {

      // ④マウスを離したらメガメニューをスライドで非表示にする
      $(this).find('.megamenu').stop().slideUp();
      $(this).removeClass('active');

  });

});

  (function(){
    let $winPos;
    let $id;
    $(window).on('scroll', function(){
      let $winPos = $(window).scrollTop();
        $('.si_header').addClass('is-hidden');
        clearTimeout($id);
        $id = setTimeout(function(){
          $('.si_header').removeClass('is-hidden');
        },300)
    })
  })();

WishlistLoadedCallback=function(){
	if($("#bookmarks").has(".price").length>0)
	{
	
		$("#bookmarks .price").each(function()
		{
					
			var current_price=$(this).html();
			$(this).html(current_price.slice(0,-3));

		});
			
	}	
};
